<template>
  <div class="preview-tag">
    <!--
    <img  v-if="tag.meta.imageSrc" class="preview-tag__image" :src="tag.meta.imageSrc" />
    -->
    <!--
    <div v-if="tag.meta.value" class="preview-tag__text-box" :style="textStyle()">
      <p v-html="textBoxContent(tag)"></p>
    </div>
    -->
    <svg v-if="tag.template === 'hotspot'" class="preview-tag__svgshape"  :viewBox="svgViewbox(tag)" width="100%" height="100%" preserveAspectRatio="none" stroke-width="1pt">
      <path v-bind:d="svgPath(tag)"  :style="svgStyle(tag)" vector-effect="non-scaling-stroke" />
    </svg>
    
    <textBoxTag ref="previewComponent" v-else-if="tag.template === 'textbox' && tag.meta && tag.meta.value" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  />
    <buttonTag ref="previewComponent" v-else-if="tag.template === 'buttonTag'" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  />
    <shopTag ref="previewComponent" v-else-if="tag.template === 'ptag'" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  />
    <quizTag ref="previewComponent" v-else-if="tag.template === 'quiz' || tag.template === 'quizzes'" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  />
    <imageTag ref="previewComponent" v-else-if="tag.template === 'imageTag'" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  />
    <div v-else>{{tag.meta.name ? tag.meta.name : tag.template}}</div>
  </div>
</template>

<script>
import marked from 'marked'
import tinycolor from 'tinycolor2'
import buttonTag from './../viewer/buttonTag'
import shopTag from './../viewer/shopTag'
import quizTag from './../viewer/quizTag'
import imageTag from './../viewer/ImageTag'
import textBoxTag from './../viewer/textBoxTag'
import shapes from './../shapes/svgpath.json'

export default {
  name: 'previewTag',

  props: {
    tag: {
      type: Object,
      default: function () {
        return {}
      }
    },
    bb: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  created() {
    // console.log("previewTag created", this.bb)
    // fallback if bb is not yet ready
    if (this.bb.width === 0 || this.bb.height === 0) {
      let vidEl = document.querySelector(".editor .player video")
      let bb = vidEl.getBoundingClientRect()
      this.dimensions.w = bb.width
      this.dimensions.h = bb.height
    }
    this.onTagMetaUpdate(this.tag.meta)
  },

  components: {
    buttonTag,
    shopTag,
    quizTag,
    imageTag,
    textBoxTag
  },

  data: function () {
    return {
      tAligns: {
        't-left': 'left',
        't-center': 'center',
        't-right': 'right',
        't-justify': 'justify'
      },
      /* default based for preview for button tag */
      frame: {
        pw: 1,
        ph: 1
      },
      /* default based for preview for button tag */
      dimensions: {
        w: this.bb.width,
        h: this.bb.height,
        scaleFactorW: 1
      }
    }
  },

  watch: {
    'tag.meta': 'onTagMetaUpdate',
    'tag.version': 'onTagMetaUpdate'
  },

  methods: {
    svgPath: function (tag) {
      const shape = shapes[tag.meta.shape.shape] || shapes['star']
      return shape.path
    },

    svgStyle: function (tag) {
      const stroke = tag.meta.shape.stroke || 'black'
      const fill = tag.meta.shape.fill || 'white'

      return {
        stroke: `rgb(${stroke.r}, ${stroke.g}, ${stroke.b})`,
        fill: `rgb(${fill.r}, ${fill.g}, ${fill.b})`
        }
    },

    svgViewbox: function (tag) {
      const shape = shapes[tag.meta.shape.shape] || shapes['star']
      return shape.viewbox
    },

    textBoxContent: function (tag) {
      let val = tag.meta.value
      return marked(val.markdown[val.markdown.lang] || '')
    },

    textStyle: function () {
      const backgroundColor = this.tag.meta.value.bgColor || 'white'
      const color = this.tag.meta.value.color || 'black'
      const textAlignement = this.tAligns[this.tag.meta.value.textAlignement] || 'center'

      return {
        'background-color': tinycolor(backgroundColor).toHex8String(),
        'color': tinycolor(color).toHex8String(),
        'width': '100%',
        'text-align': textAlignement
      }
    },

    /* 
     * force meta updates down to the previewed component
     * this is here so we do not need to replicate code all over again
     * from viewer context, as this context here behaves differently
     * forceUpdate in previewed component should kick off display logic
     */
    onTagMetaUpdate(meta) {
    
      // Set first quiz as default when null in multi quizzes
      if (meta.quizzes && !meta.quiz) {
        meta.quiz = meta.quizzes[0]
      }
      // console.log("onTagMetaUpdate", meta)
      this.$nextTick(e => {
        if (this.$refs['previewComponent']) {
          this.$refs['previewComponent'].forceUpdate(meta)
        }
      })
    }
  }
}
</script>